import type express from "express";
let _req: express.Request;

export const setReqContext = (req: express.Request) => (_req = req);

export const getReqContext = () => _req;
